import { AttachmentInformation } from './Documents.types';

export const allKindbodyUploadsAsConsents = (
  kindbodyUploads: AttachmentInformation[] | undefined
) => kindbodyUploads?.filter(attachment => attachment.purpose === 'Consents') || [];

export const allKindbodyUploadsAsNotConsents = (
  kindbodyUploads: AttachmentInformation[] | undefined
) => kindbodyUploads?.filter(attachment => attachment.purpose !== 'Consents') || [];
